
export const name = "ecosystem-marketplace-solutions-public-ui";
export const version = "dev";
